import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import usePRD3040_R01Store, { defaultPRD3040_R01Filter } from "./Store_PRD3040_R01";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SubtotalControl } from "./components/SubtotalControl";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import {  SearchSpacer, searchLabelStyle, searchDateRangeFormString } from "src/components/common/common";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";


interface Props {}

export const SearchSection_PRD3040_R01 = ({}: Props) => {
    const {
        PRD3040_R01Filter, 
        setPRD3040_R01Filter
    } = usePRD3040_R01Store();

    const {
        brandCdList,         //  브랜드 공통코드
        workPlaceList,         //  작업공정 공통코드
        compCdList         //  사업장 공통코드
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	const itemCdHandleFoucsId = 'itemCd_search';
	const productEmpHandleFoucsId = 'productEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PRD3040_R01Filter.itemCd || '',
				itemNm: PRD3040_R01Filter.itemNm || '',
			}),
		},
		{
			fieldName: 'productEmp',
			category: '작업자',
			focusId: productEmpHandleFoucsId,
			responseMapping: {
				empNo: 'productEmp',
				empNm: 'productEmpNm',
			},
			searchFunction: async (searchText: string) => {
				const employeeResponse = await getEmployeeList(searchText);
				return employeeResponse.data.data.find(value => value.empNo === searchText);
			},
			extraFilter: () => ({
				productEmp: PRD3040_R01Filter.productEmp || '',
				productEmpNm: PRD3040_R01Filter.productEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD3040_R01Filter,
		setEditData: setPRD3040_R01Filter,
		defaultData: defaultPRD3040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3040_R01_search'
	});

    // 생산기간 필터를 API 파라미터로 변환
    useEffect(() => {
        if (PRD3040_R01Filter.productDateRange?.from && PRD3040_R01Filter.productDateRange?.to) {
            // 로컬 시간대 기준으로 YYYY-MM-DD 형식 생성 (UTC 변환 방지)
            const formatDate = (date: Date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            
            const fromDate = formatDate(PRD3040_R01Filter.productDateRange.from);
            const toDate = formatDate(PRD3040_R01Filter.productDateRange.to);
            
            setPRD3040_R01Filter({
                startDate: fromDate,
                endDate: toDate
            });
        } else {
            setPRD3040_R01Filter({
                startDate: '',
                endDate: ''
            });
        }
    }, [PRD3040_R01Filter.productDateRange, setPRD3040_R01Filter]);

    // // 확장 검색 영역 렌더링 (소계 제어 추가)
    // const expandSearch = () => {
    //     return (
    //         <div className="flex items-center h-full gap-[8px] px-[12px] rounded-[6px] relative">
    //             <SubtotalControl />
    //         </div>
    //     );
    // };

    return (
        <div className="w-full">
            <SearchSectionDoubleForm >

            <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={PRD3040_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setPRD3040_R01Filter({ compCd: v === 'all' ? '' : v })}
                    wrapperOption={{
                        wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
                        titleStyle: "w-[45px] min-w-[45px] text-left",
                        selectStyle: "w-[100px] min-w-[100px]",
                    }}
                />
                <SearchDateRangeForm
                    label="생산일자"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={PRD3040_R01Filter.productDateRange}
                    setDateRange={v => setPRD3040_R01Filter({ productDateRange: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                    wrapperOption={{
                        wrapperStyle: "w-[290px] min-w-[290px] mr-[10px]",
                        titleStyle: searchLabelStyle,
                        dateRangeStyle: searchDateRangeFormString,
                    }}

                />
                <SearchDropDownForm<WorkPlaceDto>
                    label="작업공정"
                    value={PRD3040_R01Filter.workplaceCd}
                    optionList={workPlaceList}
                    onChangeValue={(v) =>
                        setPRD3040_R01Filter({
                            workplaceCd: v === "all" ? "" : v,
                        })
                    }
                    wrapperOption={{
                        wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
                        titleStyle: "w-[45px] min-w-[45px] text-left",
                        selectStyle: "w-[100px] min-w-[100px]",
                    }}
                />
                <SearchSpacer/>

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={PRD3040_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setPRD3040_R01Filter({
                            brandCd: v === "all" ? "" : v,
                        })
                    }
                    wrapperOption={{
                        wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
                        titleStyle: "w-[45px] min-w-[45px] text-left",
                        selectStyle: "w-[100px] min-w-[100px]",
                    }}
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={PRD3040_R01Filter.itemCd}
                    valueLabel={PRD3040_R01Filter.itemNm}
					handleFoucsId={itemCdHandleFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                <SearchCodeModalForm
                    label="작업자"
                    value={PRD3040_R01Filter.productEmp}
                    valueLabel={PRD3040_R01Filter.productEmpNm}
                    handleFoucsId={productEmpHandleFoucsId}
                    onChange={getFieldHandlers('productEmp').onChange}
                    onDoubleClick={getFieldHandlers('productEmp').onDoubleClick}
                    onKeyDown={getFieldHandlers('productEmp').onEnterKeyDown}
                />

                <SubtotalControl />
            </SearchSectionDoubleForm>
        </div>
    );
};
